import { List } from 'immutable';
import get from 'immutable-less/transmute/get';
import * as AccessTypes from 'automation-ui-action-features/access/constants/AccessTypes';
import ObjectTypeAccessKeys from 'automation-ui-action-features/access/constants/ObjectTypeAccessKeys';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as Scopes from 'automation-ui-action-features/constants/Scopes';
export const getIsActionDisabled = accessLevel => {
  return accessLevel === AccessTypes.PORTAL_ACCESS;
};
export const getIsActionLocked = accessLevel => {
  return accessLevel === AccessTypes.UPGRADE_ACCESS;
};
export const getIsActionNoAccess = accessLevel => {
  return accessLevel === AccessTypes.NO_ACCESS;
};
export const getAccessLevel = get(ObjectTypeAccessKeys.ACCESS_LEVEL);
export const getBaselineActionAccessLevel = get(ObjectTypeAccessKeys.BASELINE_ACTION_ACCESS_LEVEL);
const CONFIG_ID_TO_REQUIRED_ACTION_ACCESS_SCOPE = {
  [ActionTypes.EMAIL]: Scopes.EMAIL_WRITE
};
const CONFIG_ID_TO_OVERRIDE_ACTION_ACCESS_SCOPE = {
  [ActionTypes.AUTOMATION_EXTENSION]: Scopes.WORKFLOWS_EXTENSION_ACTION_ACCESS,
  [ActionTypes.WEBHOOK]: Scopes.WEBHOOK_ACCESS
};

// ObjectTypeAccess utils
export const getActionTypeAccess = get(ObjectTypeAccessKeys.ACTION_TYPE_ACCESS);

// ActionTypeAccess utils
export const getActionTypeAccessAccessLevel = get('accessLevel');
export const getActionTypeAccessActionType = get('actionType');
export const getSpecificActionAccessLevel = (access, actionType) => {
  const actionTypeAccessList = getActionTypeAccess(access) || [];
  if (Array.isArray(actionTypeAccessList) && actionTypeAccessList.length || List.isList(actionTypeAccessList) && actionTypeAccessList.size) {
    const specificActionTypeAccess = actionTypeAccessList.find(actionTypeAccess => getActionTypeAccessActionType(actionTypeAccess) === actionType);
    if (specificActionTypeAccess) {
      return getActionTypeAccessAccessLevel(specificActionTypeAccess);
    }

    /**
     * TODO ZS: workaround for missing entry for CREATE_OBJECT
     * action in the access endpoint.
     */
    if (!specificActionTypeAccess && [ActionTypes.CREATE_OBJECT, ActionTypes.ALL_DELAYS, ActionTypes.ALL_BRANCHES].includes(actionType)) {
      return AccessTypes.USER_ACCESS;
    }
  }
  return null;
};
const hasOverrideActionAccessScope = (hasScope, configId) => {
  const scope = CONFIG_ID_TO_OVERRIDE_ACTION_ACCESS_SCOPE[configId];
  if (scope) {
    return hasScope(scope);
  }
  return false;
};
const hasRequiredActionAccessScope = (hasScope, configId) => {
  const scope = CONFIG_ID_TO_REQUIRED_ACTION_ACCESS_SCOPE[configId];
  if (scope) {
    return hasScope(scope);
  }
  return true;
};
export const curriedHasSpecificActionAccessLevelWithScope = (access, hasScope, isContextualEmbed = false) => configId => {
  if (!access) {
    return null;
  }
  const baselineActionAccessLevel = getBaselineActionAccessLevel(access) || AccessTypes.USER_ACCESS;
  const actionAccessLevel = getSpecificActionAccessLevel(access, configId);
  if (actionAccessLevel) {
    let accessLevel = actionAccessLevel || access.baselineActionAccessLevel || AccessTypes.USER_ACCESS;
    if (!isContextualEmbed && hasOverrideActionAccessScope(hasScope, configId)) {
      accessLevel = AccessTypes.USER_ACCESS;
    }
    if (!hasRequiredActionAccessScope(hasScope, configId)) {
      accessLevel = AccessTypes.PORTAL_ACCESS;
    }
    return accessLevel;
  } else {
    return baselineActionAccessLevel;
  }
};